import React from 'react';
import PropTypes from 'prop-types';
import { BsXLg } from 'react-icons/bs';
import EpModal, { handleToggleModal } from '../EpModal';
import EpButton from '../EpButton';
import useTranslation from '../../hooks/useTranslation';
import './styles.scss';

const EpRecordInformationsModal = ({
  modalTitle, modalRecordLogo, modalRecordCountryName, modalRecordHospitalsCount,
  modalRecordUnitsCount, modalRecordSourceSite, modalRecordDescription,
}) => {
  // Tags do Globalization
  const NumberOfHospitals = useTranslation('Nº of hospitals');
  const NumberOfICUs = useTranslation('Nº of ICUs');
  const RegistrySite = useTranslation('Registry Site');
  const Close = useTranslation('Close');

  const bodyContent = (
    <>
      <div className="record-infos-modal__record col-12">
        <img
          className="record-infos-modal__record-logo"
          src={modalRecordLogo}
          alt="Logo do registro"
        />
        <h3 className="record-infos-modal__record-country">{modalRecordCountryName}</h3>
        {modalRecordDescription && <p className="record-infos-modal__indicators-item-title">{modalRecordDescription}</p>}
      </div>

      <div className="record-infos-modal__indicators">
        <div className="container record-infos__container--first">
          <div className="record-infos-modal__indicators-item"> {/* col-6 */}
            <h4 className="record-infos-modal__indicators-item-title">{NumberOfHospitals}</h4>
            <span className="record-infos-modal__indicators-item-value">{modalRecordHospitalsCount || '-'}</span>

          </div>

          <div className="record-infos-modal__indicators-item"> {/* col-6 */}
            <h4 className="record-infos-modal__indicators-item-title">{NumberOfICUs}</h4>
            <span className="record-infos-modal__indicators-item-value">{modalRecordUnitsCount || '-'}</span>
          </div>
        </div>

        <div className="container">
          <div className="record-infos-modal__indicators-item"> {/* col-12 */}
            <h4 className="record-infos-modal__indicators-item-title">{RegistrySite}</h4>
            {modalRecordSourceSite ? (
              <a
                className="record-infos-modal__indicators-item-link"
                href={modalRecordSourceSite}
                target="_blank"
                rel="noreferrer"
              >
                {modalRecordSourceSite}
              </a>
            ) : (
              <span className="record-infos-modal__indicators-item-value">-</span>
            )}
          </div>
        </div>
      </div>
    </>
  );

  const footerContent = (
    <EpButton
      buttonStartIcon={<BsXLg className="btn__icon" />}
      buttonType="secondary-outline"
      customClass="modal__footer-button--close"
      onClickFunc={() => handleToggleModal('modal--record-infos')}
      actionType="button"
      buttonText={Close}
      buttonSize="sm"
    />
  );

  return (
    <EpModal
      modalId="modal--record-infos"
      headerTitle={modalTitle}
      bodyContent={bodyContent}
      footerContent={footerContent}
      alignFooter="justify-content-center"
      size="lg"
    />
  );
};

export default EpRecordInformationsModal;

EpRecordInformationsModal.defaultProps = {
  modalRecordHospitalsCount: null,
  modalRecordUnitsCount: null,
  modalRecordSourceSite: null,
  modalRecordDescription: null,
};

EpRecordInformationsModal.propTypes = {
  modalTitle: PropTypes.string.isRequired,
  modalRecordLogo: PropTypes.string.isRequired,
  modalRecordCountryName: PropTypes.string.isRequired,
  modalRecordHospitalsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  modalRecordUnitsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  modalRecordSourceSite: PropTypes.string,
  modalRecordDescription: PropTypes.string,
};
